import { decomposeColor } from "@mui/material/styles";
import { colors as colorTokens } from "@/lib/theme/tokens";

const DEFAULT_COLORS = {
  primary: colorTokens.primary.light,
  secondary: colorTokens.secondary.main,
};

const HEX_COLOR = /^#([0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i;

// MUI's colour helpers (alpha, darken, ...) throw on anything they can't parse.
// Theme colours can be half-typed ("#", "#ab") while a recruiter edits the
// settings colour fields with a live preview on screen, so anything MUI can't
// use falls back to the default rather than crashing the render.
const usableColor = (value, fallback) => {
  if (typeof value !== "string" || !value.trim()) {
    return fallback;
  }

  const color = value.trim();

  // A partial hex ("#", "#ab") decomposes into a malformed rgb() string rather
  // than throwing, so hex is checked by shape before handing it to MUI.
  if (color.startsWith("#")) {
    return HEX_COLOR.test(color) ? color : fallback;
  }

  try {
    decomposeColor(color);
    return color;
  } catch {
    return fallback;
  }
};

const colors = ({ primary_color, secondary_color }) => {
  return {
    primary: usableColor(primary_color, DEFAULT_COLORS.primary),
    secondary: usableColor(secondary_color, DEFAULT_COLORS.secondary),
  };
};

export default colors;
